// Celbari wishlist: hearts on cards / product page, saved in this browser (localStorage).
// Buttons: [data-wishlist-handle]. Counters: [data-wishlist-count]. Fires 'celbari:wishlist-change'.
(() => {
  const KEY = 'celbari:wishlist';

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch {
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch {
      // storage blocked (private mode): the heart still toggles for this page view
    }
  };

  let memory = null;
  const current = () => memory || read();

  // only touches hearts whose state changed, so a page full of cards stays cheap
  const sync = () => {
    const list = current();
    document.querySelectorAll('[data-wishlist-handle]').forEach((button) => {
      const pressed = String(list.includes(button.dataset.wishlistHandle));
      if (button.getAttribute('aria-pressed') === pressed) return;
      button.setAttribute('aria-pressed', pressed);
      button.setAttribute('aria-label', pressed === 'true' ? 'Remove from wishlist' : 'Save to wishlist');
    });
    const total = String(list.length);
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      if (count.textContent !== total) count.textContent = total;
      count.hidden = list.length === 0;
    });
  };

  window.celbariWishlist = { read: current, sync };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-wishlist-handle]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.wishlistHandle;
    const list = current().slice();
    const index = list.indexOf(handle);
    if (index > -1) list.splice(index, 1);
    else list.unshift(handle);
    write(list);
    if (read().join() !== list.join()) memory = list;
    sync();
    document.dispatchEvent(new CustomEvent('celbari:wishlist-change', { detail: { list } }));
  });

  window.addEventListener('storage', (event) => {
    if (event.key === KEY) sync();
  });

  // cards added later (filters, infinite scroll, recommendations): only react when the new
  // content actually contains a heart or a counter, not on every small change to the page
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  };
  const start = () => {
    sync();
    // A heart only arrives inside a product card, the wishlist page or the product title,
    // so cheap checks are enough (no searching inside every added element, e.g. review widgets)
    const MAY_HOLD = 'product-card, .product-card, [data-wishlist-handle], [data-wishlist-count], .product-grid, product-recommendations, celbari-wishlist-page, .shopify-section';
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1 && (node.matches(MAY_HOLD) || node.closest('product-card, celbari-wishlist-page, .product-grid'))) return queue();
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
